import 'angular:locale/data:ar';
import 'angular:locale/data:en';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
